import { useState, useEffect } from "react"

import Grid from '@material-ui/core/Grid'

import Dialog from "@base/Dialog";
import { ButtonSave } from "@base/Button/ButtonForm"
import TextField from '@base/Inputs/Text/TextField'
import SelectOption from '@base/Inputs/Select/Select'

import DocumentoEnvioService from '@services/DocumentoEnvioService'

import useStatusPendencia from '@hooks/enums/useStatusPendencia';

export const TratarDiscrepanciaDialog = (props) => {
  const processo = props.processo;
  
  const listagemStatus = useStatusPendencia();

  const [formId, setFormId] = useState("");
  const [formTratamentoStatus, setFormTratamentoStatus] = useState("");  
  const [formOrigemProblemaOutro, setFormOrigemProblemaOutro] = useState("");
  const [formTratamentoEscola, setFormTratamentoEscola] = useState("");  
  const [formTratamentoInep, setFormTratamentoInep] = useState("");

  const buttonsSubmit = () => <ButtonSave onClick={tratarPendencia} />

  const tratarPendencia = () => {
    let obj = {
      status: formTratamentoStatus === "" ? undefined : formTratamentoStatus,
      descricao: formOrigemProblemaOutro === "" ? undefined : formOrigemProblemaOutro
    };

    DocumentoEnvioService.atualizarStatusDiscrepancia(props.processo.id, formId, obj).then(resultado => {
      props.handleSave(resultado);
      props.toastReference.current.show("success", "Discrepância tratada com sucesso.");
      props.handleClose();
    }).catch(error => props.toastReference.current.show("error", "Erro" + error.response.data.mensagens.map(mensagem => mensagem).join(" ,")));
  }

  const limparEstado = () => {
    setFormId("");
    setFormTratamentoStatus("");
    setFormOrigemProblemaOutro("");

    setFormTratamentoEscola("");
    setFormTratamentoInep("");
  }

  useEffect(() => {
    setFormId(props.documentoEnvio.id);
  }, [props.documentoEnvio]);

  useEffect(() => {
    if (props.documentoEnvio) {
          setFormTratamentoStatus(props.documentoEnvio.tratamentoDiscrepanciaStatus);
          setFormOrigemProblemaOutro(props.documentoEnvio.tratamentoDiscrepanciaDescricao);
		setFormTratamentoInep(props.documentoEnvio.inep);
        setFormTratamentoEscola(props.documentoEnvio.escola);
    }
  }, [formId, processo, props.documentoEnvio]);

  return (
    <>
      <Dialog
        maxWidth={"md"}
        fullWidth={true}
        closeDialog={() => { limparEstado(); props.handleClose(); }}
        openDialog={props.open}
        title="Tratar Discrepância"
        actions={buttonsSubmit()}
      >
        <Grid container spacing={3}>
          <Grid item sm={8}>
            <TextField disabled label="Escola" value={formTratamentoEscola} />
          </Grid>

          <Grid item sm={4}>
            <TextField disabled label="Código INEP" value={formTratamentoInep} />
          </Grid>
        </Grid>

        <Grid container spacing={3}>
          <Grid item sm={3}>
            <SelectOption
              label='Status'
              required
              value={formTratamentoStatus}
              name='formTratamentoStatus'
              onChange={(e) => setFormTratamentoStatus(e.target.value)}
              options={listagemStatus.data}
            />
          </Grid>

            <Grid item sm={9}>
              <TextField multiple label="Observações" value={formOrigemProblemaOutro} onChange={(e) => setFormOrigemProblemaOutro(e.target.value)} />
            </Grid>
        </Grid>

      </Dialog>
    </>
  );
}

export default TratarDiscrepanciaDialog;
